<template>
    <div id="alert" class="alert alert-danger mt-3 p-2" role="alert">
        <div>
            <h5 class="alert-heading">{{ title }}</h5>
            <div v-if="body">
                <hr class="m-0">
                <p class="mb-0 mt-1 mx-4">{{ body }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        body: String
    }
}
</script>

<style>
.alert-heading::before {
    font-family: 'Material Icons';
    content: "\e160";
    float: left;
    margin-right: 0.5rem;
    vertical-align: -50%;
    color: --bs-alert-color;
    font-weight: 400;
}
</style>